import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {PropertyGroup} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {serialize} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

const MIGRATED_VERSION:DesignerVersion = 63;

export const migration_62_63:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        const cursorPropName = SystemPropsConfigs.CURSOR_PROP_NAME;

        const prop = SystemPropsConfigs.basePropertiesConfigs.get(cursorPropName);

        const cursorPropValue = prop.defaultValue
            ? serialize(prop.defaultValue)
            : null;

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {componentDesc} = boxSnapshot;

                        componentDesc._baseProperties[cursorPropName] = {
                            id: IdUtil.newGUID(),
                            name: cursorPropName,
                            group: PropertyGroup.Base,
                            bindingIds: [],
                            _value: cursorPropValue
                        };
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
